<template>
  <div class="blackout">
    <div class="popup profile-wrap">
      <vue-headful title="Sign In | bilaskra.is" description="Sign In"/>
      <div class="title"> Innskráning
        <div class="close">
          <a @click.prevent="closePopup()">
            <img src="/img/profile/close-x.svg"/>
          </a>
        </div>
      </div>
      <hr class="hr"/>
      <fb-login>Tengjast með Facebook</fb-login>
      <div class="hr-or"><span>eða</span>
        <hr class="hr"/>
      </div>

      <form @keyup.enter="signIn" class="popup-body">
        <div class="form-group">
          <div :class="[{ 'field-error': errors.has('email') }, 'field-wrapper']">
            <input name="email" class="form-control" type="email" v-validate="'required|email'"
                   v-model="email"/>
            <label :class="{ 'filled-label': email && email.length > 0 }" v-bind:for="name">Netfang</label>
          </div>
          <div v-show="errors.has('email')" class="error"> {{ errors.first("email") }}</div>
          <!-- <div v-if="error['email']" class="error">{{error['email']}}</div>-->  </div>
        <div class="form-group">
          <div :class="[  { 'field-error': errors.has('password') },  'field-wrapper'  ]"><input
              class="form-control" type="password" name="password" v-model="password"
              v-validate="'required'"/> <label
              :class="{ 'filled-label': password && password.length > 0 }"
              v-bind:for="name">Lykilorð</label></div>
          <div v-show="errors.has('password')" class="error"> {{ errors.first("password") }}</div>
          <!-- <div v-if="error['password']" class="error">{{error['password']}}</div>-->  </div>
        <div style="clear: both;"></div>
        <div class="form-group flex-form-group" style="margin-top: 20px;">
          <div class="forgot-password-link">
            <a href="#" @click.prevent="$store.state.popup = 'forgot'">Gleymdir þú lykilorðinu þínu?</a>
          </div>
          <div>
            <PreloadBtn @click.native="signIn()" class="btn btn-success" :load="load">
              Innskrá
            </PreloadBtn>
          </div>
        </div>
      </form>
      <div class="footer f-sign-in">
                <span style="font-weight: 400;">
                    Nýskráðu þig til að vista í eftirlæti<br/>
                    og vakta leitarniðurstöður.
                </span>
        <div class="signin">
          <a href="#" @click.prevent="$store.state.popup = 'reg'">
            Nýskráning
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreloadBtn from "../PreloadBtn.vue";
import FbLogin from "../FbLogin.vue";
import {mapActions} from "vuex";

export default {
  data: function () {
    return {
      // error: [],
      email: "",
      password: "",
      load: false,
      name: ""
    };
  },
  components: {
    PreloadBtn,
    FbLogin
  },
  methods: {
    ...mapActions({
      login: 'LOGIN',
      getProfile: 'GET_PROFILE',
      getLib: 'GET_LIB',
      getFavorites: 'GET_FAVORITES',
      getNotification: 'GET_NOTIFICATIONS',
    }),
    closePopup: function () {
      if (this.$route.path == "/sign-in") {
        this.$router.push("/");
      } else {
        this.$store.state.popup = null;
      }
    },
    signIn() {
      this.$validator.validateAll().then((result) => {
        if (result) this.SignInSend();
      });
    },
    SignInSend() {
      this.load = true;

      this.login({email: this.email, password: this.password})
          .then(response => {
            this.load = false;
            if (response.data.error) {
              for (let k in response.data.error) {
                var item = response.data.error[k];

                this.$validator.errors.add({
                  field: k,
                  msg: item
                });
              }
            } else if (response.data.access_token) {
              localStorage.setItem('access_token', response.data.access_token);
              this.$store.state.access_token = response.data.access_token;
              // axios.defaults.headers.common['Authorization'] = response.data.access_token;
              this.getProfile();
              //this.getLib(true);

              this.closePopup();
              if (this.$route.name === 'Notification') {
                this.getNotification();
              }
              if (this.$route.name === 'Favorites') {
                this.getFavorites();
              }
            }
          })
          .catch((response) => {
            console.log('Res error:', response)
          });
    }
  }
};
</script>
